import React, { useState } from 'react';
import VehicleActionsMenu from '../actions/VehicleActionsMenu';
import { USER_ROLE } from '../../services/auth';

const VehicleTable = ({ vehicles, handleEdit, handleDownload, onToggleStatus, onViewExpenses, onVehicleSelected }) => {
  const u = value => String(value ?? '').toUpperCase();

  const role = localStorage.getItem(USER_ROLE);
  const isAdmin = (role === 'admin');

  const handleViewExpenses = vehicle => {
    onViewExpenses(vehicle);
  };

  return (
    <div className="hidden md:block overflow-visible relative">
      <table className="min-w-full bg-white table-auto rounded shadow text-sm">
        <thead className="bg-[#293686] text-white uppercase text-left">
          <tr>
            <th className="p-2">Vehicle No</th>
            { isAdmin && <th className="p-2">Branch</th> }
            <th className="p-2">Engine No</th>
            <th className="p-2">Type</th>
            <th className="p-2">Chassis</th>
            {/* <th className="p-2">Dimension</th> */}
            <th className="p-2">Mode</th>
            <th className="p-2">Insurance</th>
            <th className="p-2">Insurance Expiry</th>
            <th className="p-2">FC Date</th>
            <th className="p-2">Status</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((v, idx) => (
            <tr key={idx} className="border-t">
              <td className="p-2 text-[#E91C24] font-bold">
                <div className="cursor-pointer" onClick={() => onVehicleSelected(v)}>
                  {u(v.vehicle_number)}
                </div>
              </td>
              { isAdmin && <td className="p-2">{u(v?.branch?.name)}</td> }
              <td className="p-2">{u(v.rc_number)}</td>
              <td className="p-2">{u(v.vehicle_type?.name)}</td>
              <td className="p-2">{u(v.chassis_number)}</td>
              <td className="p-2">{u(v.vehicle_mode)}</td>
              {/* <td className="p-2">{v.dimension?.dimension}</td> */}
              <td className="p-2">{u(v.insurance_number)}</td>
              <td className="p-2">{v.insurance_expiry}</td>
              <td className="p-2">{v.fc_date}</td>
              <td
                className="p-2 cursor-pointer text-blue-600 hover:underline"
                onClick={() => onToggleStatus(v)}
              >
                {v.is_active ? 'ACTIVE' : 'INACTIVE'}
              </td>
              <td className="p-2">
                <VehicleActionsMenu
                  vehicle={v}
                  onEdit={() => handleEdit(v)}
                  onDownload={type => handleDownload(v, type)}
                  onViewExpensesClick={handleViewExpenses}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VehicleTable;
